import { render } from "./Detail.vue?vue&type=template&id=2ce7d708"
import script from "./Detail.vue?vue&type=script&lang=js"
export * from "./Detail.vue?vue&type=script&lang=js"

import exportComponent from "/Users/larkinwhitaker/Projects/eye-rep/modules/nova/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"Detail.vue"]])

export default __exports__